"use strict";

var getAnimation = function getAnimation(element) {
  var animation = element.getAttribute('data-tabs-animation');
  return animation ? " ".concat(animation) : '';
};

var tabs = function tabs(tab) {
  return function () {
    var tabsContainer = tab.parentNode;
    var tabsParent = tabsContainer.parentNode;
    var contentContainer = tabsParent.querySelector('.tabs__container');
    var allTabs = makeArray(tabsContainer.children);
    var tabsContent = contentContainer.children;
    var tabsIndex = allTabs.indexOf(tab);
    var active = tabsParent.querySelectorAll('.is-active');
    var animation = getAnimation(tabsParent);

    if (!hasClass(tab, 'is-active')) {
      // Remove existing is-active classes
      for (var i = 0; i < active.length; i += 1) {
        active[i].className = active[i].className.replace(' is-active', '');
        active[i].className = active[i].className.replace(animation, '');
      } // Apply is-active class to clicked tab and panel


      tab.className += ' is-active';
      tabsContent[tabsIndex].className = "tabs__content is-active".concat(animation);
    }
  };
};

var tabsArray = document.querySelectorAll('ul.tabs__list > li');

for (var i = 0; i < tabsArray.length; i += 1) {
  tabsArray[i].addEventListener('click', tabs(tabsArray[i]), false);
}